import React from "react";
import SkeletonCard from "./SkeletonCard";

const SkeletonSummaryCard = ({ iconBgColor = "bg-blue-500/20" }) => {
  return (
    <div className="relative w-64 rounded-xl bg-white/5 p-4 backdrop-blur-xl border border-white/10 overflow-hidden">
      <div className="flex items-center space-x-4">
        <div className={`flex h-12 w-12 items-center justify-center rounded-lg ${iconBgColor}`}>
          <SkeletonCard width="w-6" height="h-6" rounded="rounded" />
        </div>
        <div>
          <SkeletonCard width="w-24" height="h-4" className="mb-1" />
          <SkeletonCard width="w-20" height="h-8" />
        </div>
      </div>
      {/* Shine effect */}
      <div className="pointer-events-none absolute inset-0 -z-10 rounded-xl bg-[radial-gradient(circle_at_50%_0%,rgba(255,255,255,0.05)_0%,rgba(255,255,255,0)_25%)]"></div>
    </div>
  );
};

export default SkeletonSummaryCard; 